export const dealsKeys = {
	all: ['crm', 'deals'],
	lists: () => ['crm', 'deals', 'list'],
	list: (filters) => ['crm', 'deals', 'list', filters],
	detail: (dealId) => ['crm', 'deals', 'detail', dealId],
	// Omitting `filters` yields a prefix key that matches every filter variant —
	// which is what invalidation wants. Appending a literal `undefined` instead
	// would match nothing: partialMatchKey compares it against the cached `{}`.
	byStageInfinite: (pipelineId, stageId, filters) =>
		filters === undefined
			? ['crm', 'deals', 'byStageInfinite', pipelineId, stageId]
			: ['crm', 'deals', 'byStageInfinite', pipelineId, stageId, filters],
	allStageSummaries: () => ['crm', 'deals', 'stageSummaries'],
	stageSummaries: (pipelineId, filters) =>
		filters === undefined
			? ['crm', 'deals', 'stageSummaries', pipelineId]
			: ['crm', 'deals', 'stageSummaries', pipelineId, filters],
	allTrash: () => ['crm', 'deals', 'trash'],
	trash: (filters) => ['crm', 'deals', 'trash', filters],
};

export const dealsMutationKeys = {
	create: ['crm', 'deals', 'create'],
	update: ['crm', 'deals', 'update'],
	delete: ['crm', 'deals', 'delete'],
	restore: ['crm', 'deals', 'restore'],
	rescore: ['crm', 'deals', 'rescore'],
	bulkDelete: ['crm', 'deals', 'bulkDelete'],
	bulkRestore: ['crm', 'deals', 'bulkRestore'],
};
